import { Check, ArrowRight } from "lucide-react";
import { Card, Eyebrow, Reveal, Section, SectionHeader } from "../deck/primitives";

const BRINGS = ["Deal origination", "City relationship", "Initial proposal", "Development concept", "Preliminary underwriting", "Public-private development strategy", "Project leadership", "Sponsor role", "Development coordination"];
const WANTS = ["Commercial development experience", "Proven ability to execute", "Entitlement experience", "Predevelopment capital where appropriate", "Construction financing relationships", "Equity relationships", "Balance-sheet support if required", "General Contractor relationships", "Development consultants", "Construction execution", "Strategic guidance", "Institutional credibility"];

const List = ({ items, dark, testid }) => (
  <ul data-testid={testid} className="mt-6 grid sm:grid-cols-2 gap-x-6">
    {items.map((t) => (
      <li key={t} className={`flex items-start gap-3 py-3 border-b text-[15px] ${dark ? "border-white/10 text-white/90" : "border-line/70 text-char"}`}>
        <Check size={16} className={`mt-0.5 shrink-0 ${dark ? "text-arq-mid" : "text-arq"}`} />{t}
      </li>
    ))}
  </ul>
);

export default function JV() {
  return (
    <Section testid="section-jv">
      <SectionHeader num="11" eyebrow="JV Partnership Opportunity" title="Origination meets execution." lede="Partner with Arqitek to move the Murrieta Family Commons Project from a City-controlled opportunity to a financeable development." />
      <div className="grid lg:grid-cols-2 gap-6">
        <Reveal>
          <Card className="p-8 lg:p-10 h-full bg-ink-deep border-ink-deep text-white">
            <Eyebrow className="!text-arq-mid">What Arqitek Brings</Eyebrow>
            <div data-testid="jv-arqitek-role" className="mt-5 inline-flex rounded-full border border-arq-mid/60 px-4 py-2 font-mono text-[11px] tracking-[0.2em] text-white">
              ORIGINATING SPONSOR / MASTER DEVELOPER
            </div>
            <List items={BRINGS} dark testid="jv-brings-list" />
          </Card>
        </Reveal>
        <Reveal delay={0.1}>
          <Card className="p-8 lg:p-10 h-full">
            <Eyebrow>What We Want From the JV Partner</Eyebrow>
            <div className="mt-5 inline-flex rounded-full border border-arq/40 bg-arq-soft px-4 py-2 font-mono text-[11px] tracking-[0.2em] text-arq">
              CAPITAL · CREDIBILITY · EXECUTION
            </div>
            <List items={WANTS} testid="jv-wants-list" />
          </Card>
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <div data-testid="jv-economics-statement" className="mt-6 rounded-[16px] border border-arq/30 bg-white p-8 lg:p-10 grid lg:grid-cols-12 gap-6 items-center">
          <div className="lg:col-span-3"><Eyebrow>Partnership Economics</Eyebrow></div>
          <p className="lg:col-span-9 font-display text-2xl leading-snug text-ink">
            Joint Venture economics will be negotiated based on actual capital contribution, guarantees, development responsibilities, risk exposure and execution responsibilities.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-char">
          <span className="font-mono text-[11px] tracking-[0.2em] text-arq">NO CONSTRUCTION CAPITAL REQUEST TODAY</span>
          <ArrowRight size={14} className="text-steel" />
          <span>Immediate focus: support the City capacity package, secure protected negotiating rights, fund focused feasibility, then decide GO / REDESIGN / STOP.</span>
        </div>
      </Reveal>
    </Section>
  );
}
